import React from 'react'
import { connect } from 'react-redux'
import { open } from '../../state/accident-modal/actions'
import styled from 'styled-components'
import { Flex, Box } from 'rebass'
import { VisuallyHidden } from '../../utils/style'

import LogoTwitter from '../../vectors/LogoSocialTwitter'
import LogoFacebook from '../../vectors/LogoSocialFacebook'
import LogoLinkedIn from '../../vectors/LogoSocialLinkedin'
import LogoInstagram from '../../vectors/LogoSocialInstagram'
import OutboundLink from '../OutboundLink'

/*************************
 STYLES: Contact
 **************************/
const ContactBox = styled(Flex)`
  background: ${(props) => props.theme.colors.grey};
`

const ContactText = styled(Box)`
  letter-spacing: 0.41px;
  line-height: 1;
  color: ${(props) => props.theme.colors.grey_light};
  > strong {
    color: ${(props) => props.theme.colors.white};
  }
  a {
    white-space: nowrap;
  }
  > a {
    color: white;
    text-decoration: none;
  }
  > strong > a {
    color: ${(props) => props.theme.colors.white};
  }
`

/*************************
 STYLES: Social
 **************************/
const SocialBox = styled(Flex)`
  background: ${(props) => props.theme.colors.blue};
  list-style: none;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0;
  overflow: hidden;
`

const SocialList = styled.div`
  transform: scale(1.3);
  width: 100%;
  > a {
    text-align: center;
    margin: 0 5%;
  }

  svg > path {
    transition: fill 0.5s ${(props) => props.theme.ease.ease_out_expo};
  }
  svg:hover > path {
    fill: ${(props) => props.theme.colors.grey_op80};
  }
`

const HiddenLinkLabel = styled.span`
  ${VisuallyHidden}
`

const HeaderContractedContactSocialLinks = ({ onHadAnAccident }) => (
  <span>
    <ContactBox wrap py={35} px={'8%'}>
      <ContactText width={[1 / 1]} py={10}>
        <strong>Call us: </strong>
        <OutboundLink eventCategory="PhoneNumber" href="tel:+443300198676">
          0330 019 8676
        </OutboundLink>
      </ContactText>
      <ContactText width={[1 / 1]} py={10} textAlign="right">
        <strong>
          <a onClick={onHadAnAccident}>Accident Helpline!</a>
        </strong>
      </ContactText>
    </ContactBox>

    <SocialBox py={42} width={[1 / 1]}>
      <SocialList>
        <a href={`${process.env.SOCIAL_TWITTER}`}>
          <LogoTwitter alt="Follow us on Twitter" />
          <HiddenLinkLabel>Follow us on Twitter</HiddenLinkLabel>
        </a>

        <a href={`${process.env.SOCIAL_FACEBOOK}`}>
          <LogoFacebook alt="Find us on Facebook" />
          <HiddenLinkLabel>Find us on Facebook</HiddenLinkLabel>
        </a>

        <a href={`${process.env.SOCIAL_LINKEDIN}`}>
          <LogoLinkedIn alt="Connect with us on Linkedin" />
          <HiddenLinkLabel>Connect with us on Linkedin</HiddenLinkLabel>
        </a>

        <a href={`${process.env.SOCIAL_INSTAGRAM}`}>
          <LogoInstagram alt="Follow us on Instragram" />
          <HiddenLinkLabel>Follow us on Instragram</HiddenLinkLabel>
        </a>
      </SocialList>
    </SocialBox>
  </span>
)

const mapDispatchToProps = (dispatch) => ({
  onHadAnAccident: () => dispatch(open())
})

export default connect(
  null,
  mapDispatchToProps
)(HeaderContractedContactSocialLinks)
